import ReactDOM from 'react-dom/client';
import './index.css';
import {App} from './App';
import {  QueryClientProvider } from '@tanstack/react-query';
import { ChakraProvider } from '@chakra-ui/react'
import { queryClient } from './fetch';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
//const queryClient = new QueryClient();
root.render(
  
  
     <QueryClientProvider client={queryClient}>
        <ChakraProvider >    
           <App />
         </ChakraProvider>     
     </QueryClientProvider>
    
  
);

